import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { api } from '../services/api';

export default function LicensingSettings() {
  const { user, refreshProfile } = useAuth();
  const [settings, setSettings] = useState({
    allow_syndication: false,
    default_pricing_tier: 'standard',
    auto_approve_partners: false,
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (user) {
      setSettings({
        allow_syndication: user.allow_syndication || false,
        default_pricing_tier: user.default_pricing_tier || 'standard',
        auto_approve_partners: user.auto_approve_partners || false,
      });
    }
  }, [user]);

  const handleToggle = (field) => {
    setSettings({ ...settings, [field]: !settings[field] });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!user?.platform_agreement_signed) {
      setMessage('You must sign the platform agreement before enabling syndication.');
      return;
    }

    setLoading(true);
    setMessage('');

    try {
      await api.updateLicensing(settings);
      await refreshProfile();
      setMessage('Licensing settings updated successfully!');
    } catch (err) {
      setMessage('Error: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h2>Licensing Settings</h2>

      {!user?.platform_agreement_signed && (
        <div className="alert alert-warning">
          You must sign the platform agreement before you can enable inventory syndication.
        </div>
      )}

      {message && (
        <div className={`alert ${message.includes('Error') ? 'alert-error' : 'alert-success'}`}>
          {message}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div className="card">
          <h3>Syndication Controls</h3>

          <div className="form-group">
            <div className="toggle-group">
              <div
                className={`toggle ${settings.allow_syndication ? 'active' : ''}`}
                onClick={() => handleToggle('allow_syndication')}
              />
              <div>
                <strong>Enable Inventory Syndication</strong>
                <p style={{ margin: '5px 0 0', color: '#666', fontSize: '14px' }}>
                  When enabled, your vehicle inventory will be available to licensed partners
                </p>
              </div>
            </div>
          </div>

          <div className="form-group" style={{ marginTop: '20px' }}>
            <label>Default Pricing Tier</label>
            <select
              value={settings.default_pricing_tier}
              onChange={(e) => setSettings({ ...settings, default_pricing_tier: e.target.value })}
            >
              <option value="basic">Basic - Lower price, basic fields only</option>
              <option value="standard">Standard - Standard pricing, full vehicle details</option>
              <option value="premium">Premium - Higher price, includes photos and history</option>
            </select>
          </div>

          <div className="form-group" style={{ marginTop: '20px' }}>
            <div className="toggle-group">
              <div
                className={`toggle ${settings.auto_approve_partners ? 'active' : ''}`}
                onClick={() => handleToggle('auto_approve_partners')}
              />
              <div>
                <strong>Auto-Approve Partners</strong>
                <p style={{ margin: '5px 0 0', color: '#666', fontSize: '14px' }}>
                  Automatically approve partner subscription requests
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="card">
          <h3>Revenue Information</h3>
          <p><strong>Your Revenue Share:</strong> {user?.revenue_split_percentage || 70}%</p>
          <p><strong>Platform Fee:</strong> {100 - (user?.revenue_split_percentage || 70)}%</p>
          <p style={{ color: '#666', fontSize: '14px', marginTop: '10px' }}>
            Revenue is calculated based on partner subscriptions and usage. Payments are processed monthly.
          </p>
        </div>

        <button type="submit" className="btn btn-primary" disabled={loading || !user?.platform_agreement_signed}>
          {loading ? 'Saving...' : 'Save Settings'}
        </button>
      </form>
    </div>
  );
}
